import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const ServiceRequestDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'service-request',
        routeParamKey: 'serviceRequestId',
        pageTitle: 'ServiceRequest Details',
        backRoute: '/service-requests',
        backLabel: 'Back to ServiceRequests',
        tabIdPrefix: 'service-request',
        tabsAriaLabel: 'service-request detail tabs',
        missingIdMessage: 'No service-request ID provided in the URL.',
        noDataMessage: 'No service-request data available. The service-request might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default ServiceRequestDetailPage;
